import { MAX_ENTITIES } from "shared/src/consts";
import { defineComponentMeta } from 'shared/src/utils';

export const Renderable = {
  variant: new Uint8Array(MAX_ENTITIES),
  col: new Uint32Array(MAX_ENTITIES),

  accentCol: new Uint32Array(MAX_ENTITIES),
  seed: new Uint32Array(MAX_ENTITIES),

  roughness: new Float32Array(MAX_ENTITIES),
  glow: new Float32Array(MAX_ENTITIES),
  atmosphere: new Float32Array(MAX_ENTITIES),
  distortion: new Float32Array(MAX_ENTITIES),
  pattern: new Float32Array(MAX_ENTITIES),
  contrast: new Float32Array(MAX_ENTITIES),
  phase: new Float32Array(MAX_ENTITIES),
  
}

defineComponentMeta(Renderable, {
  name: 'Renderable',
  description: 'This entity can be rendered in the world.',
  scope: 'render',
  props: {
    variant: {
      label: 'Render variant',
      description: 'If this entity has multiple templates by which \
it can be rendered, this controls which template to use.',
      control: 'number',
      step: 1,
    },
    col: {
      label: 'Base colour',
      description: 'The base primary colour to use when rendering this entity.',
      control: 'colour',
    },
    accentCol: {
      label: 'Accent colour',
      description: 'Secondary / rim / accent colour.',
      control: 'colour'
    },
    seed: {
      label: 'Seed',
      description: 'Deterministic visual seed (uses level seed or random if === 0).',
    },
    roughness: {
      label: 'Roughness',
      description: 'Surface irregularity / texture harshness.',
      min: 0,
      max: 1,
      step: 0.01
    },
    glow: {
      label: 'Glow',
      description: 'Emitted light / bloom intensity',
      min: 0,
      max: 1,
      step: 0.01
    },
    atmosphere: {
      label: 'Atmosphere',
      description: 'Atmosphere / corona envelope strength.',
      min: 0,
      max: 1,
      step: 0.01
    },
    distortion: {
      label: 'Distortion',
      description: 'Silhouette / surface warping.',
      min: 0,
      max: 1,
      step: 0.01
    },
    pattern: {
      label: 'Pattern',
      description: 'Surface pattern / banding / mottling strength.',
      min: 0,
      max: 1,
      step: 0.01
    },
    contrast: {
      label: 'Contrast',
      description: 'Light / dark separation.',
      min: 0,
      max: 1,
      step: 0.01
    },
    phase: {
      label: 'Phase',
      description: 'Deterministic animation offset.',
      min: 0,
      max: 1,
      step: 0.01
    },
  }
});
